module.exports = __webpack_public_path__ + "img/2.126f12c1.jpg";